/*!
 * ============================================================================
 * DDN Slider Engine
 * Version : 1.0.0
 * Theme   : Horizon 3.4.0
 * Requires: assets/ddn.js
 *
 * Author  : DDN
 * ============================================================================
 */

(function () {

    if (!window.DDN) {
        console.error("DDN Core (ddn.js) is required before ddn-slider.js");
        return;
    }

    if (DDN.Slider) return;

    DDN.Slider = {};

    /**
     * Create a slider.
     *
     * @param {HTMLElement} section
     * @param {Object} options
     */
    DDN.Slider.create = function (section, options = {}) {

        if (!section) return;

        const settings = Object.assign({
            sliderSelector: ".ddn-slider-scroll",
            prevSelector: ".ddn-slider-arrow.prev",
            nextSelector: ".ddn-slider-arrow.next",
            hiddenClass: "ddn-hidden",
            scrollRatio: 0.8
        }, options);

        const slider = section.querySelector(settings.sliderSelector);
        const prev = section.querySelector(settings.prevSelector);
        const next = section.querySelector(settings.nextSelector);

        if (!slider) return;

        function updateButtons() {

            const maxScroll = slider.scrollWidth - slider.clientWidth;      
            const tolerance = 5;

            DDN.toggle(
                prev,
                settings.hiddenClass,
                slider.scrollLeft <= tolerance
            );

            DDN.toggle(
                next,
                settings.hiddenClass,
                slider.scrollLeft >= maxScroll - tolerance
            );
        }

        function scroll(direction) {

            DDN.scrollX(
                slider,
                slider.clientWidth * settings.scrollRatio * direction
            );

        }

        requestAnimationFrame(() => {
            updateButtons();
        });

        DDN.on(
            slider,
            "scroll",
            updateButtons
        );

        DDN.on(
            window,
            "resize",
            DDN.debounce(updateButtons)
        );

        DDN.on(
            prev,
            "click",
            () => scroll(-1)
        );

        DDN.on(
            next,
            "click",
            () => scroll(1)
        );

        return {

            slider,
            prev,
            next,

            update() {
                updateButtons();
            },

            scrollNext() {
                scroll(1);
            },

            scrollPrevious() {
                scroll(-1);
            }

        };

    };

})();